import alt from 'components/Dispatcher';
import CoachingPlanSource from 'sources/coaching/CoachingPlanSource';
import generateAsyncActions from 'utils/generateAsyncActions';

class PastPlanActions {
  constructor() {
    this.generateActions(...generateAsyncActions('getPastPlans'));
  }

  getPastPlans(args) {
    return dispatch => {
      dispatch(args);
      const {coachId, start, end} = args;
      return CoachingPlanSource.fetchPastPlansForCoach(coachId, start, end).then(
        this.getPastPlansSuccess,
        this.getPastPlansError
      );
    };
  }
}

export default alt.createActions(PastPlanActions);
